'use client';

import { Box, SxProps, Theme } from '@mui/material';

export function FinderContainer() {
  return <Box id="selectorDiv" sx={style} />;
}

const style: SxProps<Theme> = {
  // use a selector which has higher priority than the etilize selectors
  '&.etilize-spex-selector#selectorDiv': {
    fontFamily: theme => theme.typography.fontFamily,

    '.icon-filter-panel': {
      color: theme => theme.palette.primary.main,
    },

    '.selected .check': {
      backgroundColor: theme => theme.palette.primary.main,
    },
  },
  '&.etilize-spex-selector .item .col-description .description p': {
    display: 'none',
  },
};
